export const manifest = {
  screens: {
    scr_6pcyr3: { name: "Accueil", route: "/", position: {"x":160,"y":220} },
    scr_pud6ex: { name: "Le CFA", route: "/le-cfa", position: {"x":1560,"y":220} },
    scr_wdvaoz: { name: "Le BDE", route: "/bde", position: {"x":4360,"y":220} },
    scr_3co3d6: { name: "Nos formations", route: "/formations", position: {"x":2960,"y":220} },
    scr_njng51: { name: "Catalogue Formations 2026", route: "/catalogue", position: {"x":2960,"y":2200} },
    scr_xhjpus: { name: "Fiche BTS NDRC", route: "/formations/bts-ndrc", position: {"x":160,"y":2200} },
    scr_13jkry: { name: "Fiche TP Conseiller de Vente", route: "/formations/tp-conseiller-vente", position: {"x":1560,"y":2200} },
    scr_ojq9qu: { name: "Candidater", route: "/candidater", position: {"x":160,"y":4180} },
    scr_aht66y: { name: "Entreprises", route: "/entreprises", position: {"x":160,"y":6160} },
    scr_0pkxvn: { name: "Qualité / Qualiopi", route: "/qualite", position: {"x":160,"y":8140} },
    scr_7sa2db: { name: "Accessibilité handicap", route: "/accessibilite", position: {"x":1560,"y":8140} },
    scr_738bwt: { name: "Documents utiles", route: "/documents", position: {"x":2960,"y":8140} },
    scr_z6sxpi: { name: "Réclamations", route: "/reclamations", position: {"x":4360,"y":8140} },
    scr_i27esm: { name: "Contact", route: "/contact", position: {"x":5760,"y":8140} },
    scr_irkans: { name: "Mentions légales", route: "/mentions-legales", position: {"x":160,"y":10120} },
    scr_lqgq4t: { name: "Confidentialité", route: "/confidentialite", position: {"x":1560,"y":10120} },
    scr_rgwxzc: { name: "CGV", route: "/cgv", position: {"x":2960,"y":10120} },
  },
  sections: {
    sec_2b64rl: { name: "Main Navigation", x: 0, y: 0, width: 5720, height: 1180 },
    sec_6iw1tz: { name: "Formation Details", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_57qxyf: { name: "Application", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_5l0s43: { name: "For Businesses", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_krevht: { name: "Information & Support", x: 0, y: 7920, width: 7120, height: 1180 },
    sec_ybmnfq: { name: "Legal & Compliance", x: 0, y: 9900, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_2b64rl", children: [
      { kind: "screen", id: "scr_6pcyr3" },
      { kind: "screen", id: "scr_pud6ex" },
      { kind: "screen", id: "scr_3co3d6" },
      { kind: "screen", id: "scr_wdvaoz" },
    ] },
    { kind: "section", id: "sec_6iw1tz", children: [
      { kind: "screen", id: "scr_xhjpus" },
      { kind: "screen", id: "scr_13jkry" },
      { kind: "screen", id: "scr_njng51" },
    ] },
    { kind: "section", id: "sec_57qxyf", children: [
      { kind: "screen", id: "scr_ojq9qu" },
    ] },
    { kind: "section", id: "sec_5l0s43", children: [
      { kind: "screen", id: "scr_aht66y" },
    ] },
    { kind: "section", id: "sec_krevht", children: [
      { kind: "screen", id: "scr_0pkxvn" },
      { kind: "screen", id: "scr_7sa2db" },
      { kind: "screen", id: "scr_738bwt" },
      { kind: "screen", id: "scr_z6sxpi" },
      { kind: "screen", id: "scr_i27esm" },
    ] },
    { kind: "section", id: "sec_ybmnfq", children: [
      { kind: "screen", id: "scr_irkans" },
      { kind: "screen", id: "scr_lqgq4t" },
      { kind: "screen", id: "scr_rgwxzc" },
    ] },
  ],
}
